import { TimelineEvent } from '../Components/Timeline/Timeline';
import { calculateEventPosition, isEventActive } from './timelineUtils';

export const getActiveEvent = (currentProgress: number, events: TimelineEvent[]): TimelineEvent => {
  if (currentProgress >= 99) {
    return { year: '', title: '', img: '', content: '', picName: '' };
  }

  for (let i = 0; i < events.length; i++) {
    if (isEventActive(currentProgress, i)) {
      return events[i];
    }
  }
  
  return { year: '', title: '', img: '', content: '', picName: '' };
};